module.exports = __webpack_public_path__ + "images/bewuzt6114de5bb768f2ff914e54959c013021.png";